'use client';

import { useIsClient, useMediaQuery } from 'usehooks-ts';

export interface IWithMediaQueryProps {
  children({
    isScreen_sm,
    isScreen_md,
    isScreen_lg,
    isScreen_xl,
    isScreen_2xl,
    isScreen_3xl,
    isScreen_4xl
  }: {
    isScreen_sm: boolean;
    isScreen_md: boolean;
    isScreen_lg: boolean;
    isScreen_xl: boolean;
    isScreen_2xl: boolean;
    isScreen_3xl: boolean;
    isScreen_4xl: boolean;
  }): React.ReactNode;
}

export default function WithMediaQuery({ children }: IWithMediaQueryProps) {
  const isClient = useIsClient();
  const isScreen_sm = useMediaQuery('(min-width: 640px)');
  const isScreen_md = useMediaQuery('(min-width: 768px)');
  const isScreen_lg = useMediaQuery('(min-width: 1024px)');
  const isScreen_xl = useMediaQuery('(min-width: 1280px)');
  const isScreen_2xl = useMediaQuery('(min-width: 1440px)');
  const isScreen_3xl = useMediaQuery('(min-width: 1600px)');
  const isScreen_4xl = useMediaQuery('(min-width: 1920px)');

  if (!isClient) return null;

  return children({
    isScreen_sm,
    isScreen_md,
    isScreen_lg,
    isScreen_xl,
    isScreen_2xl,
    isScreen_3xl,
    isScreen_4xl
  });
}
